import styled from "styled-components";

export const StyledCompactError = styled.div`
  display: inline;
  color: ${(props) => props.theme.colors.accent.normal};
  pointer-events: auto;
`;
